export const weave = (...xss) => {
    const n = xss.reduce((acc, xs) => Math.max(acc, xs.length), 0)
    let result = []
    for (let i = 0; i < n; i += 1) {
        result = [...result, ...xss.map((xs) => xs[i])]
    }

    return result
}
